import React, { useEffect, useState } from 'react'
import { Text, Header2, Header3 } from '../styles/Components'
import { MembershipSection } from '../components/membership/styles'
import { loadMemberships } from '../services'
import FeaturedCard from '../components/membership/FeaturedCard'
import Card from '../components/membership/Card'
import { gsColors as c } from '../styles/Variables'
import Head from 'next/head'
import { trackProductListViewed } from '../helpers/tracking.js'
import FAQ from '../faq'
import Hero from '../components/Hero'
import HeroImg from '../../public/GS_membership_hero.jpeg'
import SelectProductButton from '../components/SelectProductButton'


export const getServerSideProps = async () => {
  const memberships = await loadMemberships()
  return {
    props: {
      memberships
    }
  }
}

const faqUrl = '/faq/category/membership'
const faqData = [
  {
    id: 1,
    title: 'Do all Glamsquad memberships automatically renew?',
    body: 'Yes, all Glamsquad memberships automatically renew on a monthly basis after any prepaid time has ended. Prepaid time may include 1 month, 3 months, or yearly.'
  },
  {
    id: 2,
    title: 'What is the Glamsquad membership?',
    body: 'The Glamsquad membership is the perfect way for you to get your favorite blowouts for less on a monthly basis. Plus, you can enjoy exclusive members-only perks such as a 10% discount on additional hair, nail and makeup services.'
  },
  {
    id: 3,
    title: 'How do I purchase the Glamsquad membership?',
    body: 'Under the Services menu on Glamsquad.com or in the Glamsquad app, click Membership. Add the Membership option to your cart and check out to purchase.'
  },
]

const Memberships = ({ memberships }) => {
  const [ selectedPackage, setSelectedPackage ] = useState(null)
  const featuredMembership = memberships.find(m => m.priority === 0)
  const introMemberships = memberships.filter(m => m.priority !== 0)

  useEffect(() => {
    trackProductListViewed('memberships', memberships)
  }, [memberships])

  return (
    <MembershipSection>
      <Head>
        <title>Beauty Membership | GLAMSQUAD</title>
        <meta name="description" content="Join GLAMSQUAD's beauty membership for a monthly blowout plus 10% off all hair, makeup, and nail services. Unused blowouts roll over — cancel anytime." />
        <link rel="canonical" href="https://glamsquad.com/membership" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Beauty Membership | GLAMSQUAD" />
        <meta property="og:description" content="Join GLAMSQUAD's membership for a monthly blowout and 10% off all additional services. Unused blowouts roll over — cancel anytime." />
        <meta property="og:url" content="https://glamsquad.com/membership" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((q) => ({
              '@type': 'Question',
              name: q.title,
              acceptedAnswer: { '@type': 'Answer', text: q.body },
            })),
          })}
        </script>
      </Head>
      <Hero 
        className='hero-class'
        header='BRING ON THE BLOWOUTS'
        image={HeroImg}
        imageAlt='Woman with a fresh GLAMSQUAD blowout enjoying her beauty membership'
        subheader='Join our Membership Program to save on your favorite blowouts and enjoy exclusive perks.' 
      />

      <div className='membership-items-section'>
        <Header2 align='center' margin='0 0 25px'>Glamsquad Membership</Header2>
        {featuredMembership && (
          <div className="card-container-featured">
            <FeaturedCard id="featured-item" featuredItem={featuredMembership} />
          </div>
        )}

        <div className="intro-offers">
          <Header3 spacing={0} margin='0 0 30px' weight={750}>Introductory Membership offers</Header3>

          <div className="cards-container">
            {introMemberships.map(m => (
              <Card
                key={m.id}
                item={m}
                selectedPackage={selectedPackage}
                select={setSelectedPackage} 
              />
            ))}
          </div>

          { selectedPackage && (
            <div className='select-product-wrapper'>
              <SelectProductButton
                color={c.sunsetOrange}
                product={selectedPackage}
                fromPath="membership"
              />
            </div>
          )}

        </div>
      </div>

      <div className='membership-perks-section'>
        <Header2>The perks of being a member</Header2>

        <div className='perk-items-wrapper'>
          <MembershipPerkItem
            title='Exclusive discounts'
            desc='Receive 10% off any additional hair, makeup and nails services, including extra blowouts. Any unused blowouts rollover to the next month.'
          />
          <MembershipPerkItem
            title='Concierge booking'
            desc='Our VIP Client Experience team is available for special assistance with booking, anytime.'
          />
          <MembershipPerkItem
            title='Pick your pro'
            desc='Choose your favorite beauty pros when booking. You can select your pros based on your previous appointments.'
          />
        </div>
      </div>

      <FAQ data={faqData} url={faqUrl} />
    </MembershipSection>
  )
}

const MembershipPerkItem = ({ title, desc }) => {
  return (
    <div className='membership-perk-item'>
      <Text margin='0 0 12px 0' weight={600} variant='medium'>{title}</Text>
      <Text>{desc}</Text>
    </div>
  )
}

export default Memberships
